// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhoneVerificationModal-btnPrimary-P6uiT {
  border-color: var(--btn-primary-bg) !important;
  background-color: var(--btn-primary-bg) !important;
  color: var(--btn-primary-color) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  border-radius: 6px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  cursor: pointer;
  line-height: 24px;
  display: inline-block;
}

.PhoneVerificationModal-btnPrimary-P6uiT:hover,
.PhoneVerificationModal-btnPrimary-P6uiT:focus,
.PhoneVerificationModal-btnPrimary-P6uiT:active,
.PhoneVerificationModal-btnPrimary-P6uiT:active:hover,
.PhoneVerificationModal-btnPrimary-P6uiT:active:focus,
.PhoneVerificationModal-btnPrimary-P6uiT[disabled]:hover,
.PhoneVerificationModal-btnPrimary-P6uiT[disabled]:focus {
  border-color: var(--btn-primary-bg-hover) !important;
  background-color: var(--btn-primary-bg-hover) !important;
  color: var(--btn-primary-color) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.PhoneVerificationModal-btnPrimaryBorder-msYbs {
  color: var(--btn-primaryBorder-color) !important;
  background-color: var(--btn-primaryBorder-bg) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  border-radius: 6px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  border: 1px solid var(--btn-primaryBorder-color) !important;
  cursor: pointer;
  line-height: 24px;
  display: inline-block;
}

.PhoneVerificationModal-btnPrimaryBorder-msYbs:hover,
.PhoneVerificationModal-btnPrimaryBorder-msYbs:focus,
.PhoneVerificationModal-btnPrimaryBorder-msYbs:active,
.PhoneVerificationModal-btnPrimaryBorder-msYbs:active:hover,
.PhoneVerificationModal-btnPrimaryBorder-msYbs:active:focus {
  color: var(--btn-primaryBorder-color) !important;
  background-color: var(--btn-primaryBorder-bg) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.PhoneVerificationModal-btnSecondary-rmVpP {
  border: 1px solid var(--btn-secondary-bg) !important;
  background-color: var(--primary-white-bg) !important;
  color: var(--btn-secondary-bg) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.PhoneVerificationModal-btnSecondary-rmVpP:hover,
.PhoneVerificationModal-btnSecondary-rmVpP:focus,
.PhoneVerificationModal-btnSecondary-rmVpP:active,
.PhoneVerificationModal-btnSecondary-rmVpP:active:hover,
.PhoneVerificationModal-btnSecondary-rmVpP:active:focus {
  border-color: var(--btn-secondary-bg) !important;
  background-color: var(--btn-secondary-bg) !important;
  color: var(--white-text) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.PhoneVerificationModal-btnPrimaryLink-dZE9q {
  border: 1px solid var(--btn-primaryBorder-color) !important;
}

.PhoneVerificationModal-nofocus-iLFiq:active:focus {
  background: var(--primary-white-bg) !important;
  color: var(--btn-primaryBorder-color) !important;
}

.PhoneVerificationModal-btnSmall-pqJv1 {
  padding: 5px 0px;
}

.PhoneVerificationModal-btnBig-lebx3 {
  padding: 12px 21px !important;
}

.PhoneVerificationModal-fullWidth-NT3iQ {
  width: 100%;
}

.PhoneVerificationModal-WidthAuto-Le8bL {
  width: auto;
}

.PhoneVerificationModal-fullHeight-Et2g2 {
  height: 100%;
}

.PhoneVerificationModal-noTextDecration-QaUVQ {
  text-decoration: none !important;
}

.PhoneVerificationModal-commonListStyleNone-vmwtF {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.PhoneVerificationModal-btnMedium-F9ODH,
.PhoneVerificationModal-btnMedium-F9ODH:hover,
.PhoneVerificationModal-btnMedium-F9ODH:focus,
.PhoneVerificationModal-btnMedium-F9ODH:focus:hover,
.PhoneVerificationModal-btnMedium-F9ODH:active,
.PhoneVerificationModal-btnMedium-F9ODH:active:hover {
  padding-inline: 19px !important;
  white-space: normal;
}

.PhoneVerificationModal-btnMediumSpace-RCbJ7,
.PhoneVerificationModal-btnMediumSpace-RCbJ7:hover,
.PhoneVerificationModal-btnMediumSpace-RCbJ7:focus,
.PhoneVerificationModal-btnMediumSpace-RCbJ7:focus:hover,
.PhoneVerificationModal-btnMediumSpace-RCbJ7:active,
.PhoneVerificationModal-btnMediumSpace-RCbJ7:active:hover {
  padding-inline: 19px !important;
  white-space: normal;
}

.PhoneVerificationModal-btnMediumPadding-pMtmQ,
.PhoneVerificationModal-btnMediumPadding-pMtmQ:hover,
.PhoneVerificationModal-btnMediumPadding-pMtmQ:focus,
.PhoneVerificationModal-btnMediumPadding-pMtmQ:active,
.PhoneVerificationModal-btnMediumPadding-pMtmQ:active:hover,
.PhoneVerificationModal-btnMediumPadding-pMtmQ:focus:hover {
  padding: 12px 19px;
}

.PhoneVerificationModal-aiAskButton-hoVoV {
  padding: 12px 18px;
  border: unset !important;
  outline: unset !important;
  border-radius: 24px 24px 24px 6px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-foreground);
  -webkit-box-shadow: 0px 2px 6px 0px #EA672021 !important;
          box-shadow: 0px 2px 6px 0px #EA672021 !important;
  background: var(--ai-badge-bg) !important;
  position: relative;
  opacity: 1 !important;
}

.PhoneVerificationModal-aiBadgeStyle-h49Bn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 4px;
  background: var(--ai-badge-bg);
  border-radius: 100px;
  position: relative;
  -webkit-box-shadow: 0px 2px 6px 0px #EA672021;
          box-shadow: 0px 2px 6px 0px #EA672021;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  padding: 4px 12px;
}

.PhoneVerificationModal-aiTextColor-e5vlb {
  background: var(--ai-foreground);
  -webkit-background-clip: text;
          background-clip: text;
  -webkit-text-fill-color: transparent;
}

.PhoneVerificationModal-aiBadgeStyle-h49Bn>svg {
  position: relative;
  top: 2px;
}

.PhoneVerificationModal-aiAskButton-hoVoV::after,
.PhoneVerificationModal-aiBadgeStyle-h49Bn::after {
  content: '';
  position: absolute;
  inset: -1px;
  background: var(--ai-border);
  border-radius: inherit;
  z-index: -1;
}

.PhoneVerificationModal-aiFooterInfoText-k55g8 {
  font-size: 12px;
  line-height: 18px;
  color: var(--secondary-foreground);
  display: inline-block;
  font-weight: 500;
}

.PhoneVerificationModal-regenerateBtn-KIXLL {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 4px;
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  border: 0;
  padding: 0px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.PhoneVerificationModal-regenerateBtn-KIXLL>svg {
  position: relative;
  top: 3px;
}

/************************ text Align ************************/

.PhoneVerificationModal-textAlignRight-Wv1By {
  text-align: right;
}

.PhoneVerificationModal-textAlignLeft-Hn2kK {
  text-align: left;
}

.PhoneVerificationModal-textAlignCenter-FlFUC {
  text-align: center;
}

/************************ text Align end ******************/

.PhoneVerificationModal-formControlInput-Fq4qK {
  padding: 10px 19px 10px 19px;
  height: 48px;
  border-radius: 6px;
  font-size: 16px;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-white-bg);
  line-height: 24px;
  color: var(--common-text-color);
  font-weight: normal;
  border: 1px solid transparent;
  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.PhoneVerificationModal-formControlSelect-bVJxL {
  padding: 10px 35px 10px 19px;
  height: 48px;
  border-radius: 6px;
  font-size: 16px;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-white-bg);
  color: var(--common-text-color);
  line-height: 19px;
  font-weight: normal;
  display: block;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.PhoneVerificationModal-noTextDecoration-zbExc {
  text-decoration: none !important;
}

/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */

.PhoneVerificationModal-picContainerMain-GTurC {
  position: relative;
}

.PhoneVerificationModal-profilePic-wgenz {
  height: 100%;
  width: 100%;
  border-radius: 12px;
}

.PhoneVerificationModal-trashIcon-hMzYn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  background: var(--common-background-color);
  padding-top: 3px;
  border: 0;
  border-radius: 2px;
  opacity: .9;
  color: var(--white-text);
  cursor: pointer;
}

.PhoneVerificationModal-trashIconNew-H7OwR {
  position: absolute;
  top: 18px;
  right: 18px;
}

.PhoneVerificationModal-trashIconNew-H7OwR img {
  width: 36px;
}

.PhoneVerificationModal-bannerImageBg-nWjqT {
  width: 100%;
  height: 100%;
  min-height: 179px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  position: relative;
  border-radius: 0px;
}

.PhoneVerificationModal-profileImageBg-K4YDt {
  padding-top: 36%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 100%;
  max-width: 180px;
  margin: 0 auto;
  background-position: 50% 50%;
  background-size: 66px;
}

.PhoneVerificationModal-whiteImg-bWxU2 {
  background: var(--modalText-color);
  border-radius: 0px;
}

.PhoneVerificationModal-curserPointer-H2lrP {
  cursor: pointer;
}

.PhoneVerificationModal-adminLabelTextNew-lhfhP {
  font-size: 18px;
  font-weight: 500;
  color: var(--common-text-color);
}

/*-----------------------Profilephoto Upload Common Styles End----------------------------- */

/******************* Admin Modal ListSetting Start *******************/

.PhoneVerificationModal-radioBtn-AYoL7 {
  position: relative;
  top: 1px;
  vertical-align: middle;
  margin-left: 3px;
}

.PhoneVerificationModal-displayinlineBlock-KuBO9 {
  display: inline-block;
}

.PhoneVerificationModal-displayBlock-KoSHT {
  display: block;
}

.PhoneVerificationModal-displayFlex-VpIuW {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.PhoneVerificationModal-inlineDisplayFlex-d0Y_a {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.PhoneVerificationModal-alignCenter-JuEUK {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.PhoneVerificationModal-spaceBetween-OBwx3 {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.PhoneVerificationModal-alignItemFlexStart-h8Xtr {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

/******************* Admin Modal ListSetting Start *******************/

.PhoneVerificationModal-commonTitleText-YW6gD {
  font-size: 36px;
  margin: 0px;
  word-wrap: break-word;
}

.PhoneVerificationModal-commonSubTitleText-Utvv9 {
  font-size: 20px;
  margin: 0px;
}

.PhoneVerificationModal-commonContentText-oKGYq {
  font-size: 18px;
  line-height: 28px;
  margin: 0px;
}

.PhoneVerificationModal-commonMediumText-DDWob {
  font-size: 16px;
  line-height: 24px;
  margin: 0px;
}

.PhoneVerificationModal-commonTotalText-UvYQ0 {
  font-size: 24px;
  line-height: 30px;
  margin: 0px;
}

.PhoneVerificationModal-commonSmallText-NY7Go {
  font-size: 14px;
  line-height: 20px;
  margin: 0px;
}

.PhoneVerificationModal-fontWeightExtraBold-bs1Kx {
  font-weight: 700;
}

.PhoneVerificationModal-fontWeightBold-JDEoJ {
  font-weight: 600;
}

.PhoneVerificationModal-fontWeightMedium-tILQ3 {
  font-weight: 500;
}

.PhoneVerificationModal-fontWeightNormal-spVWP {
  font-weight: 400;
}

.PhoneVerificationModal-textDecorationUnderLine-SFgjI {
  text-decoration: underline;
}

.PhoneVerificationModal-textDecorationNone-L7Z7k {
  text-decoration: none !important;
}

.PhoneVerificationModal-siteLinkColor-AtN5C,
.PhoneVerificationModal-siteLinkColor-AtN5C:hover,
.PhoneVerificationModal-siteLinkColor-AtN5C:focus,
.PhoneVerificationModal-siteLinkColor-AtN5C:active {
  color: var(--common-link-color);
}

.PhoneVerificationModal-commonLinkBorderBottom-PcgxW {
  border-bottom: 1px solid var(--common-link-color);
}

.PhoneVerificationModal-siteTextColor-P3bLL,
.PhoneVerificationModal-siteTextColor-P3bLL:hover,
.PhoneVerificationModal-siteTextColor-P3bLL:focus,
.PhoneVerificationModal-siteTextColor-P3bLL:active {
  color: var(--common-text-color);
}

.PhoneVerificationModal-positionRelative-BE6f5 {
  position: relative;
}

.PhoneVerificationModal-listingHorizoltalLine-eIOrB {
  margin: 40px 0px;
  border-top: 1px solid var(--primary-border);
}

/******************************* Common Margin Start *****************************/

.PhoneVerificationModal-spaceBottom0-NhsC8 {
  margin-bottom: 0px;
}

.PhoneVerificationModal-spaceBottom1-_yTzl {
  margin-bottom: 6px;
}

.PhoneVerificationModal-spaceBottom2-uflPy {
  margin-bottom: 12px;
}

.PhoneVerificationModal-spaceBottom3-JKa9G {
  margin-bottom: 18px;
}

.PhoneVerificationModal-spaceBottom4-dbO0k {
  margin-bottom: 24px;
}

.PhoneVerificationModal-spaceBottom5-qk5E3 {
  margin-bottom: 30px;
}

.PhoneVerificationModal-spaceBottom6-ajQv3 {
  margin-bottom: 36px;
}

.PhoneVerificationModal-spaceBottom7-FzhtS {
  margin-bottom: 42px;
}

.PhoneVerificationModal-spaceBottom8-LyWk0 {
  margin-bottom: 10px;
}

.PhoneVerificationModal-spaceTop0-JDYEg {
  margin-top: 0px;
}

.PhoneVerificationModal-spaceTop1-OBuOx {
  margin-top: 6px;
}

.PhoneVerificationModal-spaceTop2-kdSsd {
  margin-top: 12px;
}

.PhoneVerificationModal-spaceTop3-_DvDF {
  margin-top: 18px;
}

.PhoneVerificationModal-spaceTop4-AGEjU {
  margin-top: 24px;
}

.PhoneVerificationModal-spaceTop5-F8OQm {
  margin-top: 30px;
}

.PhoneVerificationModal-spaceTop6-urYzu {
  margin-top: 36px;
}

.PhoneVerificationModal-spaceTop7-ZVpMw {
  margin-top: 42px;
}

.PhoneVerificationModal-paddingBottom1-HqiML {
  padding-bottom: 6px;
}

.PhoneVerificationModal-paddingBottom2-SEg4E {
  padding-bottom: 12px;
}

.PhoneVerificationModal-paddingBottom3-R1Yk1 {
  padding-bottom: 18px;
}

.PhoneVerificationModal-paddingBottom4-yaCtX {
  padding-bottom: 24px;
}

.PhoneVerificationModal-paddingBottom5-rSMBg {
  padding-bottom: 30px;
}

.PhoneVerificationModal-paddingBottom6-ueji_ {
  padding-bottom: 36px;
}

.PhoneVerificationModal-paddingBottom7-J4FCV {
  padding-bottom: 42px;
}

.PhoneVerificationModal-paddingTop1-I82t6 {
  padding-top: 6px;
}

.PhoneVerificationModal-paddingTop2-smJp4 {
  padding-top: 12px;
}

.PhoneVerificationModal-paddingTop3-IXGa5 {
  padding-top: 18px;
}

.PhoneVerificationModal-paddingTop4-nkjLC {
  padding-top: 24px;
}

.PhoneVerificationModal-paddingTop5-lo4Y5 {
  padding-top: 30px;
}

.PhoneVerificationModal-paddingTop6-EBpTW {
  padding-top: 36px;
}

.PhoneVerificationModal-paddingTop7-vmZ28 {
  padding-top: 42px;
}

.PhoneVerificationModal-spaceRight1-haqX3 {
  margin-right: 6px;
}

.PhoneVerificationModal-spaceRight2-SJ3CL {
  margin-right: 12px;
}

.PhoneVerificationModal-spaceRight3-h5LNh {
  margin-right: 18px;
}

.PhoneVerificationModal-spaceRight4-PpCGD {
  margin-right: 24px;
}

.PhoneVerificationModal-paddingBottom8-mfEd2 {
  padding-bottom: 15px;
}

.PhoneVerificationModal-spaceTop8-ohqx9 {
  margin-top: 16px;
}

.PhoneVerificationModal-paddingBottomNone-U_okQ {
  padding-bottom: 0;
}

.PhoneVerificationModal-spaceBottom9-ZUfZU {
  margin-bottom: 16px;
}

.PhoneVerificationModal-spaceBottom10-azhUF {
  margin-bottom: 17px;
}

.PhoneVerificationModal-spaceBottom11-mCB9s {
  margin-bottom: 7px;
}

.PhoneVerificationModal-spaceBottom12-ysYMh {
  margin-bottom: 20px;
}

.PhoneVerificationModal-noPadding-PND3z {
  padding: 0px;
}

.PhoneVerificationModal-flexShrinkNone-eLGGf {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

/******************************* Common Margin And Padding End *****************************/

.PhoneVerificationModal-viewListIcon-TGwWR {
  width: 100%;
  max-width: 35px;
  min-width: 35px;
}

.PhoneVerificationModal-blueLeftArrow-_yON0 {
  padding-left: 6px;
  position: relative;
}

.PhoneVerificationModal-profileAvatarLink-wv08Q {
  border: 2.5px solid var(--common-link-color);
  border-radius: 50%;
  display: inline-block;
  padding: 7px;
  background-color: var(--dashBoard-info-bg);
}

.PhoneVerificationModal-profileAvatarLinkSmall-rlP3C {
  padding: 2px
}

.PhoneVerificationModal-errorMessage-UhqB8 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

.PhoneVerificationModal-textTransformLowerCase-swV8r {
  text-transform: lowercase;
}

.PhoneVerificationModal-passwordIcon-p8Eh5 {
  position: absolute;
  right: 18px;
  top: 43px;
  cursor: pointer;
}

.PhoneVerificationModal-noMargin-prE0u {
  margin: 0px;
}

.PhoneVerificationModal-noMarginBottom-am61M {
  margin-bottom: 0 !important;
}

.PhoneVerificationModal-dotCss-V5z_n {
  width: 4px;
  height: 4px;
  background: var(--common-background-color);
  border-radius: 50%;
  margin: 0px 4px;
  display: inline-block;
  position: relative;
  top: -3px;
}

.PhoneVerificationModal-dateArrowMargin-dxdnQ {
  margin: 0px 8px;
}

.PhoneVerificationModal-commonBorderSection-hKAuA {
  --wrapper-Padding: 24px;
  border: 1px solid var(--primary-border);
  padding: 18px 24px;
  padding: 18px var(--wrapper-Padding);
  border-radius: 12px;
}

.PhoneVerificationModal-vtrMiddle-WWgqj {
  vertical-align: middle;
}

.PhoneVerificationModal-positionAvatar-z3Xf0 {
  position: absolute;
  top: 15px;
  right: 15px;
}

/* display flex properties */

.PhoneVerificationModal-dFlex-bUVJL {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.PhoneVerificationModal-flexWrap-DenVB {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.PhoneVerificationModal-dInlineFlex-O9px0 {
  display: inline-block;
  display: -webkit-inline-box;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.PhoneVerificationModal-dFlexContainer-lulOU {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.PhoneVerificationModal-dFlexWrap-r6MRC {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.PhoneVerificationModal-dFlexWrapAlignEnd-gNw0Y {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.PhoneVerificationModal-dFlexWrapAlignStart-hzDG6 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.PhoneVerificationModal-justifyContentSpaceBetween-W0rN9 {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.PhoneVerificationModal-greyText-EKD8h {
  color: var(--modalText-color);
}

.PhoneVerificationModal-tripsReservationPanel-cNeIP {
  border-radius: 12px;
  width: 100%;
  display: block;
  border: 1px solid var(--primary-border);
  background: var(--primary-white-bg);
  padding: 15px 24px 24px 24px;
}

.PhoneVerificationModal-listContainer-PpKQx {
  margin: 0px;
  padding: 0px;
  list-style: none;
  border-bottom: 1px solid var(--primary-border);
}

.PhoneVerificationModal-listTabItem-LHYih {
  display: block;
  padding: 0px 0px 7px;
  position: relative;
  text-align: center;
  font-size: 18px;
  color: var(--modalText-color);
  cursor: pointer;
  border-bottom: 1px solid transparent;
  margin-right: 30px;
}

.PhoneVerificationModal-listTabItem-LHYih:hover,
.PhoneVerificationModal-listTabItem-LHYih:active,
.PhoneVerificationModal-listTabItem-LHYih:focus,
.PhoneVerificationModal-listTabItem-LHYih:active:hover,
.PhoneVerificationModal-listTabItem-LHYih:focus:hover {
  text-decoration: none;
  color: var(--common-text-color);
}

.PhoneVerificationModal-reviewsContainer-mcTE2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-column-gap: 6px;
     -moz-column-gap: 6px;
          column-gap: 6px;
}

.PhoneVerificationModal-reviewsYourItemsOne-m9rUX {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}

.PhoneVerificationModal-reviewsYourItemsTwo-UqznW {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
}

.PhoneVerificationModal-rightBg-XNpYF {
  background: var(--common-gray-bg-color);
  border-radius: 0 8px 8px 8px;
  padding: 16px 18px 18px 18px;
  width: 100%;
  position: relative;
  -webkit-border-radius: 0 8px 8px 8px;
  -moz-border-radius: 0 8px 8px 8px;
  -ms-border-radius: 0 8px 8px 8px;
  -o-border-radius: 0 8px 8px 8px;
}

.PhoneVerificationModal-commonProfileAvatarLink-cmkWi {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 68px;
  height: 68px;
  overflow: hidden;
  border-radius: 50%;
  border: 2px solid var(--common-link-color);
  background-color: transparent;
  padding: 3px;
  position: relative;
  z-index: 5;
}

.PhoneVerificationModal-commonProfileAvatarLink-cmkWi img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  background-color: var(--primary-white-bg);
  border-radius: 50%;
}

.PhoneVerificationModal-writtenReviewTitle-KQu0W {
  font-weight: 500;
  margin-bottom: 6px;
  word-break: break-word;
  color: var(--common-text-color);
  font-size: 18px;
}

.PhoneVerificationModal-reviewTitleLink-tg9wY {
  color: var(--common-link-color);
  font-weight: 500;
}

.PhoneVerificationModal-reviewTitleLink-tg9wY:hover,
.PhoneVerificationModal-reviewTitleLink-tg9wY:focus,
.PhoneVerificationModal-reviewTitleLink-tg9wY:active,
.PhoneVerificationModal-reviewTitleLink-tg9wY:active:hover {
  color: var(--common-link-color);

}

.PhoneVerificationModal-reviewFlex-yF1S_ {
  -webkit-column-gap: 5px;
     -moz-column-gap: 5px;
          column-gap: 5px;
  font-size: 14px;
  color: var(--common-text-color);
  margin-bottom: 6px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.PhoneVerificationModal-noTop-fCY9v {
  top: 0;
}

.PhoneVerificationModal-reviewPara-cNvsg {
  color: var(--common-text-color);
  word-break: break-word;
}

.PhoneVerificationModal-dFlexColumn-Y2fqD {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.PhoneVerificationModal-commonlineCss-qdK4s {
  margin: 18px 0;
  border: 1px solid var(--primary-border);
}

.PhoneVerificationModal-rightBg-XNpYF::after {
  content: "";
  position: absolute;
  left: -38px;
  top: 0;
  right: auto;
  width: 38px;
  height: 40px;
  background: var(--primary-white-bg);
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  z-index: 3;
}

.PhoneVerificationModal-rightBg-XNpYF::before {
  content: " ";
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  bottom: auto;
  border: 10px solid transparent;
  border-left: 0;
  border-right-color: var(--primary-white-bg);
  top: 0;
  left: auto;
  right: 100%;
  border-width: 0 24px 24px 0;
  border-color: transparent #F9F9F9 transparent transparent;
}

.PhoneVerificationModal-loadBtn-cBKrq {
  border-color: var(--btn-primary-bg);
  color: var(--white-text);
  height: 48px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: var(--btn-primary-bg);
  border-radius: 6px;
  padding: 12px 19px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}

.PhoneVerificationModal-loadBtn-cBKrq:hover,
.PhoneVerificationModal-loadBtn-cBKrq:active,
.PhoneVerificationModal-loadBtn-cBKrq:focus,
.PhoneVerificationModal-loadBtn-cBKrq:active:hover,
.PhoneVerificationModal-loadBtn-cBKrq:active:focus,
.PhoneVerificationModal-loadBtn-cBKrq[disabled]:hover,
.PhoneVerificationModal-loadBtn-cBKrq[disabled]:focus {
  color: var(--white-text);
  border-color: var(--btn-primary-bg);
  background: var(--btn-primary-bg);
}

.PhoneVerificationModal-vtrTop-wTUPd {
  vertical-align: top;
}

.PhoneVerificationModal-reviewHeadingColor-AaicX {
  color: var(--common-text-color);
}

.PhoneVerificationModal-reviewWriteHeading-zj0aQ {
  font-weight: 500;
  word-break: break-word;
  color: var(--common-text-color);
  font-size: 18px;
}

.PhoneVerificationModal-noDataImgSize-LH9gE {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

.PhoneVerificationModal-justifyCenter-E3kNg {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.PhoneVerificationModal-btnTextBrk-Cbubr {
  white-space: normal;
  word-break: break-word;
}

.PhoneVerificationModal-marginInlineAuto-uVPaH {
  margin-inline: auto;
}

.PhoneVerificationModal-noItemPanel-DEh2w {
  background: var(--primary-white-bg);
  border-radius: 12px;
  border: 1px solid var(--primary-border);
  padding: 44px 0;
}

.PhoneVerificationModal-textLineBreak-MRN38 {
  word-break: break-word;
}

.PhoneVerificationModal-displayBlock-KoSHT {
  display: block;
}

.PhoneVerificationModal-displayInlineBlock-joZZF {
  display: inline-block;
}

.PhoneVerificationModal-commonContainerList-Ah_VF {
  width: 100%;
  max-width: var(--max-listing-width);
  margin: 0 auto;
}

.PhoneVerificationModal-adminBorderWithoutPadding-bl8GO {
  border: 1px solid var(--primary-border);
  border-radius: 4px;
}

.PhoneVerificationModal-marginRight8-jXTsB {
  margin-right: 8px;
}

.PhoneVerificationModal-adminDotIconBtn-S8nl4,
.PhoneVerificationModal-adminDotIconBtn-S8nl4:hover,
.PhoneVerificationModal-adminDotIconBtn-S8nl4:focus,
.PhoneVerificationModal-adminDotIconBtn-S8nl4:active {
  border: none;
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.PhoneVerificationModal-commonLinkBorder-FSD3E {
  border-bottom: 1px solid var(--common-link-color);
}

.PhoneVerificationModal-commonTabelDropDownBg-OU_tN {
  background: var(--common-gray-bg-color);
  -webkit-box-shadow: 0px 3px 6px #00000029;
          box-shadow: 0px 3px 6px #00000029;
  border-radius: 6px;
  padding: 10px;
}

.PhoneVerificationModal-tabelDropDownBtn-jm1VT,
.PhoneVerificationModal-tabelDropDownBtn-jm1VT:hover,
.PhoneVerificationModal-tabelDropDownBtn-jm1VT:active,
.PhoneVerificationModal-tabelDropDownBtn-jm1VT:focus {
  padding: 12px 10px !important;
  border: none;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  background-color: transparent !important;
  font-size: 16px;
  color: var(--common-text-color);
  line-height: inherit;
  vertical-align: top;
  border-radius: 0;
}

.PhoneVerificationModal-tableHorizantalLine-juUmQ {
  border-color: var(--primary-border);
  margin: 6px 0px;
}

.PhoneVerificationModal-backArrowStyle-jj9XX {
  width: 15px;
  height: 12px;
  margin-right: 6px;
}

.PhoneVerificationModal-csvImageSpace-NMF_l {
  margin: 0px 6px;
}

.PhoneVerificationModal-flexEnd-SeA3Y {
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}

.PhoneVerificationModal-justifyContentFlexEnd-r0nZj {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.PhoneVerificationModal-profileAvatarLinkPayment-TST7G {
  padding: 5px;
}

.PhoneVerificationModal-alignItemBaseline-p3DZ4 {
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
}

.PhoneVerificationModal-payOutToolTip-fytLG {
  margin: 0 3px;
}

.PhoneVerificationModal-tolltipMargin-Tp06q {
  margin: 0 3px;
}

.PhoneVerificationModal-textNoWrap-hDzsE {
  white-space: nowrap;
}

.PhoneVerificationModal-commonSearchInputFilterContainer-myuIb {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  grid-gap: 16px;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}

.PhoneVerificationModal-mobileTableSearch-vQlXX {
  margin-bottom: 24px;
  gap: 16px;
  grid-gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.PhoneVerificationModal-mobileTableOnlyLink-4WwDs {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.PhoneVerificationModal-linkBtnPrimaryStyle-WERtf {
  background-color: transparent !important;
  color: var(--common-link-color);
  padding: 0;
  border: unset;
  -webkit-box-shadow: unset !important;
          box-shadow: unset !important;
  border-bottom: 1px solid var(--common-link-color);
  font-weight: 500;
  font-size: 18px;
  text-decoration: none;
  line-height: 26px;
  border-radius: 0 !important;
  white-space: normal;
}

.PhoneVerificationModal-linkBtnPrimaryStyle-WERtf:hover,
.PhoneVerificationModal-linkBtnPrimaryStyle-WERtf:focus,
.PhoneVerificationModal-linkBtnPrimaryStyle-WERtf:active,
.PhoneVerificationModal-linkBtnPrimaryStyle-WERtf:active:hover {
  color: var(--common-link-color);
  border-bottom: 1px solid var(--common-link-color);
}

.PhoneVerificationModal-dataTableGrid-Zl0q9 {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 4px;
}

.PhoneVerificationModal-paymentDivider-oSySJ {
  border-bottom: 1px solid var(--primary-border);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.PhoneVerificationModal-paymentDivider-oSySJ:last-child {
  border-bottom: unset;
  margin-bottom: 0;
  padding-bottom: 0;
}

.PhoneVerificationModal-bulletList-zndbV {
  list-style: disc;
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
}

.PhoneVerificationModal-commonSmallText14-Nw8pE {
  font-size: 14px;
  line-height: 20px;
}

.PhoneVerificationModal-commonSmallText16-UrpZB {
  font-size: 16px;
  line-height: 22px;
}

.PhoneVerificationModal-commonSmallText18-XUsNj {
  font-size: 18px;
  line-height: 24px;
}

.PhoneVerificationModal-commonSmallText20-Ydp4r {
  font-size: 20px;
  line-height: 26px;
}

.PhoneVerificationModal-commonSmallText24-pqc1D {
  font-size: 24px;
  line-height: 30px;
}

.PhoneVerificationModal-commonSmallText26-FEEkG {
  font-size: 26px;
  line-height: normal;
}

.PhoneVerificationModal-top1-paHdB {
  top: 1px;
}

.PhoneVerificationModal-top2-ZtOqg {
  top: 2px;
}

.PhoneVerificationModal-top3-MGGG5 {
  top: 3px
}

.PhoneVerificationModal-topMinus1-kWet_ {
  top: -1px;
}

.PhoneVerificationModal-topMinus2-WAGtA {
  top: -2px;
}

.PhoneVerificationModal-topMinus3-vF2ZA {
  top: -3px
}

.PhoneVerificationModal-textEnd-zB6Zw {
  text-align: end;
}

.PhoneVerificationModal-textAlignCenter-FlFUC {
  text-align: center;
}

.PhoneVerificationModal-textStart-tTLWx {
  text-align: start;
}

.PhoneVerificationModal-flexGrow-oT3lX {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}

/* dropzone */

.PhoneVerificationModal-imageUploadDropzoneSection-Shroj {
  border-radius: 12px;
  width: 100%;
  height: 180px;
  position: relative;
}

.PhoneVerificationModal-imageUploadDropzoneSectionOutline-E92Hj {
  background-color: var(--secondary-gray-bg);
  border: 2px dashed var(--primary-border);
}

.PhoneVerificationModal-commonDropZoneImgContainer-vYSLg {
  position: absolute;
  inset: 0;
  -o-object-fit: contain;
     object-fit: contain;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  -o-object-position: center;
     object-position: center;
  background-size: contain;
  background-position: center;
}

.PhoneVerificationModal-commonDropZoneDefaultImg-FhZFk {
  background-size: 70px 70px;
}

.PhoneVerificationModal-navTabFlex-u1QR8 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px 30px;
  border-bottom: 1px solid var(--primary-border);
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
}

.PhoneVerificationModal-navTabLink-qhM4D {
  font-size: 18px;
  line-height: 24px;
  color: var(--tertiary-foreground) !important;
  padding-bottom: 6px;
  text-decoration: none !important;
  position: relative;
  text-align: center;
  display: block;
  cursor: pointer;
}

.PhoneVerificationModal-navTabLink-qhM4D.PhoneVerificationModal-activeTabStyle-nzvZr {
  color: var(--primary-foreground) !important;
  font-weight: 500;
}

.PhoneVerificationModal-navTabLink-qhM4D.PhoneVerificationModal-activeTabStyle-nzvZr::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: var(--primary-link-foreground) !important;
  bottom: -1px;
  left: 0;
  right: 0;
}

.PhoneVerificationModal-listingCardCarTypeAndTransmissionLabelFlexContainer-YWogc {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  color: var(--primary-foreground);
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.PhoneVerificationModal-listingCardCarTypeAndTransmissionLabelFlexContainer-YWogc>div {
  max-width: 50%;
}

.PhoneVerificationModal-transmissionLabelText-aKNNC {
  position: relative;
  -webkit-padding-start: 15px;
          padding-inline-start: 15px;
}

.PhoneVerificationModal-transmissionLabelText-aKNNC::before {
  content: '';
  position: absolute;
  width: 4px;
  height: 4px;
  background: var(--common-background-color);
  border-radius: 50%;
  left: 5px;
  top: 8px;
}

.PhoneVerificationModal-carTypeIcon-BChAg {
  position: relative;
  top: -2px;
}

.PhoneVerificationModal-textFlow-vHpU1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.PhoneVerificationModal-dividerBorder-iEBwj {
  border-bottom: 1px solid var(--primary-border);
}

.PhoneVerificationModal-commonNoteText-ONKQE {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0 0;
  line-height: normal;
  font-weight: normal;
}

@media screen and (min-width:992px) {
  .PhoneVerificationModal-paymentSticky-rVCTO {
    position: sticky !important;
    position: -webkit-sticky;
    top: 42px
  }
}

@media (max-width: 1024px) and (min-width: 768px) {
  .PhoneVerificationModal-dateArrowMargin-dxdnQ {
    margin: 0px -10px;
  }
}

@media screen and (max-width: 767px) {
  .PhoneVerificationModal-btnWidth-HGojn {
    width: 100%;
  }

  .PhoneVerificationModal-mobTextCenter-cLHdm {
    text-align: center !important;
  }

  .PhoneVerificationModal-tripsReservationPanel-cNeIP {
    padding-inline: 15px;
  }

  .PhoneVerificationModal-listContainer-PpKQx {
    border-bottom: unset;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .PhoneVerificationModal-listContainer-PpKQx li .PhoneVerificationModal-listTabItem-LHYih {
    margin-right: 0;
    margin-left: 0;
  }

  .PhoneVerificationModal-writtenReviewTitle-KQu0W,
  .PhoneVerificationModal-reviewTitleLink-tg9wY {
    font-size: 16px;
  }

  .PhoneVerificationModal-reviewFlex-yF1S_ {
    font-size: 12px;
  }

  .PhoneVerificationModal-reviewPara-cNvsg {
    font-size: 14px;
  }

  .PhoneVerificationModal-commonProfileAvatarLink-cmkWi {
    width: 50px;
    height: 50px;
  }

  .PhoneVerificationModal-reviewWriteHeading-zj0aQ {
    font-size: 16px;
  }

  .PhoneVerificationModal-mobileReviewIconBox-G2K3u {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
  }

  .PhoneVerificationModal-mrMarginBottom-MiwCf {
    margin-bottom: 5px;
  }

  .PhoneVerificationModal-mrRemoveMargin-cZi6x {
    margin-right: 0;
  }

  .PhoneVerificationModal-mrListDeletBtnBox-DsGRT {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .PhoneVerificationModal-mobileFlexContainer-c0VUo {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .PhoneVerificationModal-mobileFlexContainer-c0VUo li {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }

  .PhoneVerificationModal-mobileDisplayBlock-J7IZr {
    display: block;
  }

  .PhoneVerificationModal-mobileTextCenter-U9f_n {
    text-align: center;
  }

  .PhoneVerificationModal-profileImageBg-K4YDt,
  .PhoneVerificationModal-bannerImageBg-nWjqT {
    padding-top: 60%;
  }

  .PhoneVerificationModal-trashIconNew-H7OwR {
    top: 12px;
    right: 12px;
  }

  .PhoneVerificationModal-mobileTableSearch-vQlXX {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
  }

  .PhoneVerificationModal-commonBorderSection-hKAuA {
    --wrapper-Padding: 18px;
  }

  .PhoneVerificationModal-commonSearchInputFilterContainer-myuIb {
    width: 100%;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .PhoneVerificationModal-mobileTableOnlyLink-4WwDs {
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: flex-end;
  }

  .PhoneVerificationModal-navTabFlex-u1QR8 {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
    border: unset;
  }
}

.PhoneVerificationModal-displayGrid-waGLl {
  display: grid;
}

.PhoneVerificationModal-gridCols2-R0YRg {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.PhoneVerificationModal-gap4-vxkcn {
  gap: 4px;
}

.PhoneVerificationModal-gap6-R0pDt {
  gap: 6px;
}

.PhoneVerificationModal-gap8-o2imu {
  gap: 8px;
}

.PhoneVerificationModal-gap12-hLhAX {
  gap: 12px;
}

.PhoneVerificationModal-gap16-I0o9B {
  gap: 16px;
}

.PhoneVerificationModal-gap24-luMax {
  gap: 24px;
}

.PhoneVerificationModal-columnGap16-qQ7kG {
  -webkit-column-gap: 16px;
     -moz-column-gap: 16px;
          column-gap: 16px;
}

.PhoneVerificationModal-rowGap18-V3tDZ {
  row-gap: 18px;
}

.PhoneVerificationModal-bt-uLV05 {
  border-top: 1px solid var(--primary-border);
}

.PhoneVerificationModal-languageBox-cPTOW>div:not(:first-child) {
  padding-top: 24px;
  border-top: 1px solid var(--primary-border);
  margin-top: 24px;
}

.PhoneVerificationModal-languageBtnContainerOne-FOaDC {
  margin-bottom: 24px;
}

.PhoneVerificationModal-languageBox-cPTOW>div:last-child .PhoneVerificationModal-languageBtnContainerOne-FOaDC {
  margin-bottom: 0;
}

.PhoneVerificationModal-commonInputGrpDivider-zNMZm {
  padding-bottom: 18px;
  border-bottom: 1px solid var(--primary-border);
}

@media screen and (max-width: 991px) {
  .PhoneVerificationModal-gridColsTab1-u2xGh {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .PhoneVerificationModal-gapTab0-KC5rb {
    gap: 0px !important;
  }
}

@media screen and (max-width: 767px) {
  .PhoneVerificationModal-gridColsMobile1-NA6Ui {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .PhoneVerificationModal-mobileFlexColumn-MPD1G {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .PhoneVerificationModal-mobileAlignFlexStretch-m0ZWJ {
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
  }
}

.PhoneVerificationModal-plusIcon-SaGgo {
   width: 20px;
   height: 20px;
   -ms-flex-negative: 0;
       flex-shrink: 0;
}

.PhoneVerificationModal-countryCodeSec-iNso6 {
    padding: 14px 17px;
    background: var(--btn-primary-bg);
    color: var(--btn-primary-color);
    border-radius: 6px 0px 0px 6px;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.PhoneVerificationModal-phoneNumberSec-hclzS {
    padding: 14px 20px;
}

.PhoneVerificationModal-clearOption-U3wUM {
    padding: 14px 20px 14px 0;
}

.PhoneVerificationModal-phoneVerifyModal-5yUve {
    border-radius: 6px;
}

.PhoneVerificationModal-iconSize-ckTTh {
    max-width: 13px;
    max-height: 13px;
}

.PhoneVerificationModal-sendBtn-Rzx3g {
    white-space: normal;
    word-break: break-word;
}

.PhoneVerificationModal-confirmedText-P5fQU {
    color: var(--verified-color);
}

.PhoneVerificationModal-confirmedIcon-EdXrB {
    width: 12px;
    height: 8px;
    margin-right: 3px;
    vertical-align: baseline;
}

@media screen and (max-width:767px) {

    .PhoneVerificationModal-phoneNumberSec-hclzS {
        padding-right: 10px;
        padding-left: 10px;
    }

    .PhoneVerificationModal-countryCodeSec-iNso6 {
        padding-inline: 12px;
    }

    .PhoneVerificationModal-phoneVerifyModal-5yUve {
        padding: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/commonStyle.css","webpack://./src/components/PhoneVerificationModal/PhoneVerificationModal.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,kDAAkD;EAClD,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,oDAAoD;EACpD,wDAAwD;EACxD,0CAA0C;EAC1C,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,2DAA2D;EAC3D,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;;EAKE,gDAAgD;EAChD,wDAAwD;EACxD,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,oDAAoD;EACpD,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;;;;EAKE,gDAAgD;EAChD,oDAAoD;EACpD,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,wDAAgD;UAAhD,gDAAgD;EAChD,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,QAAQ;EACR,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,6CAAqC;UAArC,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,6BAAqB;UAArB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA,6DAA6D;;AAC7D;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2DAA2D;;AAC3D;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,yCAAyC;EACzC,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,yCAAyC;EACzC,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAgB;OAAhB,gBAAgB;EAChB,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,+FAA+F;;AAC/F;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,6FAA6F;;AAC7F,sEAAsE;;AACtE;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA,sEAAsE;;AACtE;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,kFAAkF;;AAClF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAc;MAAd,cAAc;AAChB;;AAEA,4FAA4F;;AAC5F;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,kBAAoC;EAApC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,4BAA4B;;AAE5B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAe;MAAf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,mBAAe;MAAf,eAAe;EACf,uBAAuB;EACvB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uCAAuC;EACvC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;;EAKE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,uBAAe;KAAf,oBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;;EAIE,+BAA+B;;AAEjC;;AAEA;EACE,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,2CAA2C;EAC3C,MAAM;EACN,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,YAAY;EACZ,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;EAOE,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,YAAY;EACZ,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;EACvC,yCAAiC;UAAjC,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;EAIE,6BAA6B;EAC7B,YAAY;EACZ,mCAA2B;UAA3B,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAGA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,UAAU;EACV,aAAa;EACb,oCAA4B;UAA5B,4BAA4B;EAC5B,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;;EAIE,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2BAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;;AAEA,aAAa;;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAmB;KAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,0BAAuB;KAAvB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2DAA2D;EAC3D,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;;AAGA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;IAC3B,wBAAwB;IACxB;EACF;AACF;;AAGA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,mBAAe;QAAf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,mBAAe;QAAf,eAAe;EACjB;;EAEA;IACE,sBAAqB;QAArB,mBAAqB;YAArB,qBAAqB;EACvB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;IACpB,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;EACtB;AACF;;AC5jDA;GACG,WAAW;GACX,YAAY;GACZ,oBAAc;OAAd,cAAc;AACjB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,+BAA+B;IAC/B,8BAA8B;IAC9B,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,wBAAwB;AAC5B;;AAGA;;IAEI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".btnPrimary {\n  border-color: var(--btn-primary-bg) !important;\n  background-color: var(--btn-primary-bg) !important;\n  color: var(--btn-primary-color) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  border-radius: 6px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  cursor: pointer;\n  line-height: 24px;\n  display: inline-block;\n}\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus,\n.btnPrimary[disabled]:hover,\n.btnPrimary[disabled]:focus {\n  border-color: var(--btn-primary-bg-hover) !important;\n  background-color: var(--btn-primary-bg-hover) !important;\n  color: var(--btn-primary-color) !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryBorder {\n  color: var(--btn-primaryBorder-color) !important;\n  background-color: var(--btn-primaryBorder-bg) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  border-radius: 6px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  border: 1px solid var(--btn-primaryBorder-color) !important;\n  cursor: pointer;\n  line-height: 24px;\n  display: inline-block;\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n  color: var(--btn-primaryBorder-color) !important;\n  background-color: var(--btn-primaryBorder-bg) !important;\n  box-shadow: none !important;\n}\n\n.btnSecondary {\n  border: 1px solid var(--btn-secondary-bg) !important;\n  background-color: var(--primary-white-bg) !important;\n  color: var(--btn-secondary-bg) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  box-shadow: none !important;\n}\n\n.btnSecondary:hover,\n.btnSecondary:focus,\n.btnSecondary:active,\n.btnSecondary:active:hover,\n.btnSecondary:active:focus {\n  border-color: var(--btn-secondary-bg) !important;\n  background-color: var(--btn-secondary-bg) !important;\n  color: var(--white-text) !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryLink {\n  border: 1px solid var(--btn-primaryBorder-color) !important;\n}\n\n.nofocus:active:focus {\n  background: var(--primary-white-bg) !important;\n  color: var(--btn-primaryBorder-color) !important;\n}\n\n.btnSmall {\n  padding: 5px 0px;\n}\n\n.btnBig {\n  padding: 12px 21px !important;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.WidthAuto {\n  width: auto;\n}\n\n.fullHeight {\n  height: 100%;\n}\n\n.noTextDecration {\n  text-decoration: none !important;\n}\n\n.commonListStyleNone {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.btnMedium,\n.btnMedium:hover,\n.btnMedium:focus,\n.btnMedium:focus:hover,\n.btnMedium:active,\n.btnMedium:active:hover {\n  padding-inline: 19px !important;\n  white-space: normal;\n}\n\n.btnMediumSpace,\n.btnMediumSpace:hover,\n.btnMediumSpace:focus,\n.btnMediumSpace:focus:hover,\n.btnMediumSpace:active,\n.btnMediumSpace:active:hover {\n  padding-inline: 19px !important;\n  white-space: normal;\n}\n\n.btnMediumPadding,\n.btnMediumPadding:hover,\n.btnMediumPadding:focus,\n.btnMediumPadding:active,\n.btnMediumPadding:active:hover,\n.btnMediumPadding:focus:hover {\n  padding: 12px 19px;\n}\n\n.aiAskButton {\n  padding: 12px 18px;\n  border: unset !important;\n  outline: unset !important;\n  border-radius: 24px 24px 24px 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--primary-foreground);\n  box-shadow: 0px 2px 6px 0px #EA672021 !important;\n  background: var(--ai-badge-bg) !important;\n  position: relative;\n  opacity: 1 !important;\n}\n\n.aiBadgeStyle {\n  display: inline-flex;\n  gap: 4px;\n  background: var(--ai-badge-bg);\n  border-radius: 100px;\n  position: relative;\n  box-shadow: 0px 2px 6px 0px #EA672021;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  padding: 4px 12px;\n}\n\n.aiTextColor {\n  background: var(--ai-foreground);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.aiBadgeStyle>svg {\n  position: relative;\n  top: 2px;\n}\n\n.aiAskButton::after,\n.aiBadgeStyle::after {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  background: var(--ai-border);\n  border-radius: inherit;\n  z-index: -1;\n}\n\n.aiFooterInfoText {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--secondary-foreground);\n  display: inline-block;\n  font-weight: 500;\n}\n\n.regenerateBtn {\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  display: flex;\n  gap: 4px;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: 0;\n  padding: 0px;\n  align-items: center;\n}\n\n.regenerateBtn>svg {\n  position: relative;\n  top: 3px;\n}\n\n/************************ text Align ************************/\n.textAlignRight {\n  text-align: right;\n}\n\n.textAlignLeft {\n  text-align: left;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n/************************ text Align end ******************/\n.formControlInput {\n  padding: 10px 19px 10px 19px;\n  height: 48px;\n  border-radius: 6px;\n  font-size: 16px;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-white-bg);\n  line-height: 24px;\n  color: var(--common-text-color);\n  font-weight: normal;\n  border: 1px solid transparent;\n  -webkit-appearance: none !important;\n  box-shadow: none !important;\n}\n\n.formControlSelect {\n  padding: 10px 35px 10px 19px;\n  height: 48px;\n  border-radius: 6px;\n  font-size: 16px;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-white-bg);\n  color: var(--common-text-color);\n  line-height: 19px;\n  font-weight: normal;\n  display: block;\n  appearance: none;\n  -webkit-appearance: none !important;\n  box-shadow: none !important;\n}\n\n.noTextDecoration {\n  text-decoration: none !important;\n}\n\n/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */\n.picContainerMain {\n  position: relative;\n}\n\n.profilePic {\n  height: 100%;\n  width: 100%;\n  border-radius: 12px;\n}\n\n.trashIcon {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 22px;\n  height: 22px;\n  background: var(--common-background-color);\n  padding-top: 3px;\n  border: 0;\n  border-radius: 2px;\n  opacity: .9;\n  color: var(--white-text);\n  cursor: pointer;\n}\n\n.trashIconNew {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n}\n\n.trashIconNew img {\n  width: 36px;\n}\n\n.bannerImageBg {\n  width: 100%;\n  height: 100%;\n  min-height: 179px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  position: relative;\n  border-radius: 0px;\n}\n\n.profileImageBg {\n  padding-top: 36%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 100%;\n  height: 100%;\n  max-width: 180px;\n  margin: 0 auto;\n  background-position: 50% 50%;\n  background-size: 66px;\n}\n\n.whiteImg {\n  background: var(--modalText-color);\n  border-radius: 0px;\n}\n\n.curserPointer {\n  cursor: pointer;\n}\n\n.adminLabelTextNew {\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--common-text-color);\n}\n\n/*-----------------------Profilephoto Upload Common Styles End----------------------------- */\n/******************* Admin Modal ListSetting Start *******************/\n.radioBtn {\n  position: relative;\n  top: 1px;\n  vertical-align: middle;\n  margin-left: 3px;\n}\n\n.displayinlineBlock {\n  display: inline-block;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.inlineDisplayFlex {\n  display: inline-flex;\n}\n\n.alignCenter {\n  align-items: center;\n}\n\n.spaceBetween {\n  justify-content: space-between;\n}\n\n.alignItemFlexStart {\n  align-items: flex-start;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n.commonTitleText {\n  font-size: 36px;\n  margin: 0px;\n  word-wrap: break-word;\n}\n\n.commonSubTitleText {\n  font-size: 20px;\n  margin: 0px;\n}\n\n.commonContentText {\n  font-size: 18px;\n  line-height: 28px;\n  margin: 0px;\n}\n\n.commonMediumText {\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0px;\n}\n\n.commonTotalText {\n  font-size: 24px;\n  line-height: 30px;\n  margin: 0px;\n}\n\n.commonSmallText {\n  font-size: 14px;\n  line-height: 20px;\n  margin: 0px;\n}\n\n.fontWeightExtraBold {\n  font-weight: 700;\n}\n\n.fontWeightBold {\n  font-weight: 600;\n}\n\n.fontWeightMedium {\n  font-weight: 500;\n}\n\n.fontWeightNormal {\n  font-weight: 400;\n}\n\n.textDecorationUnderLine {\n  text-decoration: underline;\n}\n\n.textDecorationNone {\n  text-decoration: none !important;\n}\n\n.siteLinkColor,\n.siteLinkColor:hover,\n.siteLinkColor:focus,\n.siteLinkColor:active {\n  color: var(--common-link-color);\n}\n\n.commonLinkBorderBottom {\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.siteTextColor,\n.siteTextColor:hover,\n.siteTextColor:focus,\n.siteTextColor:active {\n  color: var(--common-text-color);\n}\n\n.positionRelative {\n  position: relative;\n}\n\n.listingHorizoltalLine {\n  margin: 40px 0px;\n  border-top: 1px solid var(--primary-border);\n}\n\n/******************************* Common Margin Start *****************************/\n.spaceBottom0 {\n  margin-bottom: 0px;\n}\n\n.spaceBottom1 {\n  margin-bottom: 6px;\n}\n\n.spaceBottom2 {\n  margin-bottom: 12px;\n}\n\n.spaceBottom3 {\n  margin-bottom: 18px;\n}\n\n.spaceBottom4 {\n  margin-bottom: 24px;\n}\n\n.spaceBottom5 {\n  margin-bottom: 30px;\n}\n\n.spaceBottom6 {\n  margin-bottom: 36px;\n}\n\n.spaceBottom7 {\n  margin-bottom: 42px;\n}\n\n.spaceBottom8 {\n  margin-bottom: 10px;\n}\n\n.spaceTop0 {\n  margin-top: 0px;\n}\n\n.spaceTop1 {\n  margin-top: 6px;\n}\n\n.spaceTop2 {\n  margin-top: 12px;\n}\n\n.spaceTop3 {\n  margin-top: 18px;\n}\n\n.spaceTop4 {\n  margin-top: 24px;\n}\n\n.spaceTop5 {\n  margin-top: 30px;\n}\n\n.spaceTop6 {\n  margin-top: 36px;\n}\n\n.spaceTop7 {\n  margin-top: 42px;\n}\n\n.paddingBottom1 {\n  padding-bottom: 6px;\n}\n\n.paddingBottom2 {\n  padding-bottom: 12px;\n}\n\n.paddingBottom3 {\n  padding-bottom: 18px;\n}\n\n.paddingBottom4 {\n  padding-bottom: 24px;\n}\n\n.paddingBottom5 {\n  padding-bottom: 30px;\n}\n\n.paddingBottom6 {\n  padding-bottom: 36px;\n}\n\n.paddingBottom7 {\n  padding-bottom: 42px;\n}\n\n.paddingTop1 {\n  padding-top: 6px;\n}\n\n.paddingTop2 {\n  padding-top: 12px;\n}\n\n.paddingTop3 {\n  padding-top: 18px;\n}\n\n.paddingTop4 {\n  padding-top: 24px;\n}\n\n.paddingTop5 {\n  padding-top: 30px;\n}\n\n.paddingTop6 {\n  padding-top: 36px;\n}\n\n.paddingTop7 {\n  padding-top: 42px;\n}\n\n.spaceRight1 {\n  margin-right: 6px;\n}\n\n.spaceRight2 {\n  margin-right: 12px;\n}\n\n.spaceRight3 {\n  margin-right: 18px;\n}\n\n.spaceRight4 {\n  margin-right: 24px;\n}\n\n.paddingBottom8 {\n  padding-bottom: 15px;\n}\n\n.spaceTop8 {\n  margin-top: 16px;\n}\n\n.paddingBottomNone {\n  padding-bottom: 0;\n}\n\n.spaceBottom9 {\n  margin-bottom: 16px;\n}\n\n.spaceBottom10 {\n  margin-bottom: 17px;\n}\n\n.spaceBottom11 {\n  margin-bottom: 7px;\n}\n\n.spaceBottom12 {\n  margin-bottom: 20px;\n}\n\n.noPadding {\n  padding: 0px;\n}\n\n.flexShrinkNone {\n  flex-shrink: 0;\n}\n\n/******************************* Common Margin And Padding End *****************************/\n.viewListIcon {\n  width: 100%;\n  max-width: 35px;\n  min-width: 35px;\n}\n\n.blueLeftArrow {\n  padding-left: 6px;\n  position: relative;\n}\n\n.profileAvatarLink {\n  border: 2.5px solid var(--common-link-color);\n  border-radius: 50%;\n  display: inline-block;\n  padding: 7px;\n  background-color: var(--dashBoard-info-bg);\n}\n\n.profileAvatarLinkSmall {\n  padding: 2px\n}\n\n.errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}\n\n.textTransformLowerCase {\n  text-transform: lowercase;\n}\n\n.passwordIcon {\n  position: absolute;\n  right: 18px;\n  top: 43px;\n  cursor: pointer;\n}\n\n.noMargin {\n  margin: 0px;\n}\n\n.noMarginBottom {\n  margin-bottom: 0 !important;\n}\n\n.dotCss {\n  width: 4px;\n  height: 4px;\n  background: var(--common-background-color);\n  border-radius: 50%;\n  margin: 0px 4px;\n  display: inline-block;\n  position: relative;\n  top: -3px;\n}\n\n.dateArrowMargin {\n  margin: 0px 8px;\n}\n\n.commonBorderSection {\n  --wrapper-Padding: 24px;\n  border: 1px solid var(--primary-border);\n  padding: 18px var(--wrapper-Padding);\n  border-radius: 12px;\n}\n\n.vtrMiddle {\n  vertical-align: middle;\n}\n\n.positionAvatar {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n/* display flex properties */\n\n.dFlex {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n}\n\n.flexWrap {\n  flex-wrap: wrap;\n}\n\n.dInlineFlex {\n  display: inline-block;\n  display: -webkit-inline-box;\n  align-items: center;\n}\n\n.dFlexContainer {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dFlexWrap {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.dFlexWrapAlignEnd {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.dFlexWrapAlignStart {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.justifyContentSpaceBetween {\n  justify-content: space-between;\n}\n\n.greyText {\n  color: var(--modalText-color);\n}\n\n.tripsReservationPanel {\n  border-radius: 12px;\n  width: 100%;\n  display: block;\n  border: 1px solid var(--primary-border);\n  background: var(--primary-white-bg);\n  padding: 15px 24px 24px 24px;\n}\n\n.listContainer {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.listTabItem {\n  display: block;\n  padding: 0px 0px 7px;\n  position: relative;\n  text-align: center;\n  font-size: 18px;\n  color: var(--modalText-color);\n  cursor: pointer;\n  border-bottom: 1px solid transparent;\n  margin-right: 30px;\n}\n\n.listTabItem:hover,\n.listTabItem:active,\n.listTabItem:focus,\n.listTabItem:active:hover,\n.listTabItem:focus:hover {\n  text-decoration: none;\n  color: var(--common-text-color);\n}\n\n.reviewsContainer {\n  display: flex;\n  align-items: flex-start;\n  column-gap: 6px;\n}\n\n.reviewsYourItemsOne {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n}\n\n.reviewsYourItemsTwo {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 100%;\n  flex: 1 1 100%;\n}\n\n.rightBg {\n  background: var(--common-gray-bg-color);\n  border-radius: 0 8px 8px 8px;\n  padding: 16px 18px 18px 18px;\n  width: 100%;\n  position: relative;\n  -webkit-border-radius: 0 8px 8px 8px;\n  -moz-border-radius: 0 8px 8px 8px;\n  -ms-border-radius: 0 8px 8px 8px;\n  -o-border-radius: 0 8px 8px 8px;\n}\n\n.commonProfileAvatarLink {\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: 68px;\n  height: 68px;\n  overflow: hidden;\n  border-radius: 50%;\n  border: 2px solid var(--common-link-color);\n  background-color: transparent;\n  padding: 3px;\n  position: relative;\n  z-index: 5;\n}\n\n.commonProfileAvatarLink img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: var(--primary-white-bg);\n  border-radius: 50%;\n}\n\n.writtenReviewTitle {\n  font-weight: 500;\n  margin-bottom: 6px;\n  word-break: break-word;\n  color: var(--common-text-color);\n  font-size: 18px;\n}\n\n.reviewTitleLink {\n  color: var(--common-link-color);\n  font-weight: 500;\n}\n\n.reviewTitleLink:hover,\n.reviewTitleLink:focus,\n.reviewTitleLink:active,\n.reviewTitleLink:active:hover {\n  color: var(--common-link-color);\n\n}\n\n.reviewFlex {\n  column-gap: 5px;\n  font-size: 14px;\n  color: var(--common-text-color);\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.noTop {\n  top: 0;\n}\n\n.reviewPara {\n  color: var(--common-text-color);\n  word-break: break-word;\n}\n\n.dFlexColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.commonlineCss {\n  margin: 18px 0;\n  border: 1px solid var(--primary-border);\n}\n\n.rightBg::after {\n  content: \"\";\n  position: absolute;\n  left: -38px;\n  top: 0;\n  right: auto;\n  width: 38px;\n  height: 40px;\n  background: var(--primary-white-bg);\n  border-top-right-radius: 30px;\n  border-bottom-left-radius: 30px;\n  z-index: 3;\n}\n\n.rightBg::before {\n  content: \" \";\n  position: absolute;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  bottom: auto;\n  border: 10px solid transparent;\n  border-left: 0;\n  border-right-color: var(--primary-white-bg);\n  top: 0;\n  left: auto;\n  right: 100%;\n  border-width: 0 24px 24px 0;\n  border-color: transparent #F9F9F9 transparent transparent;\n}\n\n.loadBtn {\n  border-color: var(--btn-primary-bg);\n  color: var(--white-text);\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  background: var(--btn-primary-bg);\n  border-radius: 6px;\n  padding: 12px 19px;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.loadBtn:hover,\n.loadBtn:active,\n.loadBtn:focus,\n.loadBtn:active:hover,\n.loadBtn:active:focus,\n.loadBtn[disabled]:hover,\n.loadBtn[disabled]:focus {\n  color: var(--white-text);\n  border-color: var(--btn-primary-bg);\n  background: var(--btn-primary-bg);\n}\n\n.vtrTop {\n  vertical-align: top;\n}\n\n.reviewHeadingColor {\n  color: var(--common-text-color);\n}\n\n.reviewWriteHeading {\n  font-weight: 500;\n  word-break: break-word;\n  color: var(--common-text-color);\n  font-size: 18px;\n}\n\n.noDataImgSize {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.justifyCenter {\n  justify-content: center;\n}\n\n.btnTextBrk {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.marginInlineAuto {\n  margin-inline: auto;\n}\n\n.noItemPanel {\n  background: var(--primary-white-bg);\n  border-radius: 12px;\n  border: 1px solid var(--primary-border);\n  padding: 44px 0;\n}\n\n.textLineBreak {\n  word-break: break-word;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.displayInlineBlock {\n  display: inline-block;\n}\n\n.commonContainerList {\n  width: 100%;\n  max-width: var(--max-listing-width);\n  margin: 0 auto;\n}\n\n.adminBorderWithoutPadding {\n  border: 1px solid var(--primary-border);\n  border-radius: 4px;\n}\n\n.marginRight8 {\n  margin-right: 8px;\n}\n\n.adminDotIconBtn,\n.adminDotIconBtn:hover,\n.adminDotIconBtn:focus,\n.adminDotIconBtn:active {\n  border: none;\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.commonLinkBorder {\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.commonTabelDropDownBg {\n  background: var(--common-gray-bg-color);\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 6px;\n  padding: 10px;\n}\n\n.tabelDropDownBtn,\n.tabelDropDownBtn:hover,\n.tabelDropDownBtn:active,\n.tabelDropDownBtn:focus {\n  padding: 12px 10px !important;\n  border: none;\n  box-shadow: none !important;\n  background-color: transparent !important;\n  font-size: 16px;\n  color: var(--common-text-color);\n  line-height: inherit;\n  vertical-align: top;\n  border-radius: 0;\n}\n\n.tableHorizantalLine {\n  border-color: var(--primary-border);\n  margin: 6px 0px;\n}\n\n.backArrowStyle {\n  width: 15px;\n  height: 12px;\n  margin-right: 6px;\n}\n\n.csvImageSpace {\n  margin: 0px 6px;\n}\n\n.flexEnd {\n  align-items: flex-end;\n}\n\n.justifyContentFlexEnd {\n  justify-content: flex-end;\n}\n\n.profileAvatarLinkPayment {\n  padding: 5px;\n}\n\n.alignItemBaseline {\n  align-items: baseline;\n}\n\n.payOutToolTip {\n  margin: 0 3px;\n}\n\n.tolltipMargin {\n  margin: 0 3px;\n}\n\n.textNoWrap {\n  white-space: nowrap;\n}\n\n\n.commonSearchInputFilterContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  grid-gap: 16px;\n  flex-grow: 1;\n}\n\n.mobileTableSearch {\n  margin-bottom: 24px;\n  gap: 16px;\n  grid-gap: 16px;\n  flex-wrap: wrap;\n}\n\n.mobileTableOnlyLink {\n  justify-content: flex-end;\n}\n\n.linkBtnPrimaryStyle {\n  background-color: transparent !important;\n  color: var(--common-link-color);\n  padding: 0;\n  border: unset;\n  box-shadow: unset !important;\n  border-bottom: 1px solid var(--common-link-color);\n  font-weight: 500;\n  font-size: 18px;\n  text-decoration: none;\n  line-height: 26px;\n  border-radius: 0 !important;\n  white-space: normal;\n}\n\n.linkBtnPrimaryStyle:hover,\n.linkBtnPrimaryStyle:focus,\n.linkBtnPrimaryStyle:active,\n.linkBtnPrimaryStyle:active:hover {\n  color: var(--common-link-color);\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.dataTableGrid {\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  gap: 4px;\n}\n\n.paymentDivider {\n  border-bottom: 1px solid var(--primary-border);\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n}\n\n.paymentDivider:last-child {\n  border-bottom: unset;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.bulletList {\n  list-style: disc;\n  padding-inline-start: 25px;\n}\n\n.commonSmallText14 {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.commonSmallText16 {\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.commonSmallText18 {\n  font-size: 18px;\n  line-height: 24px;\n}\n\n.commonSmallText20 {\n  font-size: 20px;\n  line-height: 26px;\n}\n\n.commonSmallText24 {\n  font-size: 24px;\n  line-height: 30px;\n}\n\n.commonSmallText26 {\n  font-size: 26px;\n  line-height: normal;\n}\n\n.top1 {\n  top: 1px;\n}\n\n.top2 {\n  top: 2px;\n}\n\n.top3 {\n  top: 3px\n}\n\n.topMinus1 {\n  top: -1px;\n}\n\n.topMinus2 {\n  top: -2px;\n}\n\n.topMinus3 {\n  top: -3px\n}\n\n.textEnd {\n  text-align: end;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.textStart {\n  text-align: start;\n}\n\n.flexGrow {\n  flex-grow: 1;\n}\n\n/* dropzone */\n.imageUploadDropzoneSection {\n  border-radius: 12px;\n  width: 100%;\n  height: 180px;\n  position: relative;\n}\n\n.imageUploadDropzoneSectionOutline {\n  background-color: var(--secondary-gray-bg);\n  border: 2px dashed var(--primary-border);\n}\n\n.commonDropZoneImgContainer {\n  position: absolute;\n  inset: 0;\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  object-position: center;\n  background-size: contain;\n  background-position: center;\n}\n\n.commonDropZoneDefaultImg {\n  background-size: 70px 70px;\n}\n\n.navTabFlex {\n  display: flex;\n  align-items: center;\n  gap: 12px 30px;\n  border-bottom: 1px solid var(--primary-border);\n  list-style: none;\n  padding: 0;\n  margin: 0 0 24px;\n}\n\n.navTabLink {\n  font-size: 18px;\n  line-height: 24px;\n  color: var(--tertiary-foreground) !important;\n  padding-bottom: 6px;\n  text-decoration: none !important;\n  position: relative;\n  text-align: center;\n  display: block;\n  cursor: pointer;\n}\n\n.navTabLink.activeTabStyle {\n  color: var(--primary-foreground) !important;\n  font-weight: 500;\n}\n\n.navTabLink.activeTabStyle::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  background-color: var(--primary-link-foreground) !important;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n}\n\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer {\n  display: flex;\n  font-size: 14px;\n  color: var(--primary-foreground);\n  align-items: center;\n}\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer>div {\n  max-width: 50%;\n}\n\n.transmissionLabelText {\n  position: relative;\n  padding-inline-start: 15px;\n}\n\n.transmissionLabelText::before {\n  content: '';\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  background: var(--common-background-color);\n  border-radius: 50%;\n  left: 5px;\n  top: 8px;\n}\n\n.carTypeIcon {\n  position: relative;\n  top: -2px;\n}\n\n.textFlow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dividerBorder {\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.commonNoteText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0 0;\n  line-height: normal;\n  font-weight: normal;\n}\n\n@media screen and (min-width:992px) {\n  .paymentSticky {\n    position: sticky !important;\n    position: -webkit-sticky;\n    top: 42px\n  }\n}\n\n\n@media (max-width: 1024px) and (min-width: 768px) {\n  .dateArrowMargin {\n    margin: 0px -10px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .btnWidth {\n    width: 100%;\n  }\n\n  .mobTextCenter {\n    text-align: center !important;\n  }\n\n  .tripsReservationPanel {\n    padding-inline: 15px;\n  }\n\n  .listContainer {\n    border-bottom: unset;\n    flex-wrap: wrap;\n  }\n\n  .listContainer li .listTabItem {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .writtenReviewTitle,\n  .reviewTitleLink {\n    font-size: 16px;\n  }\n\n  .reviewFlex {\n    font-size: 12px;\n  }\n\n  .reviewPara {\n    font-size: 14px;\n  }\n\n  .commonProfileAvatarLink {\n    width: 50px;\n    height: 50px;\n  }\n\n  .reviewWriteHeading {\n    font-size: 16px;\n  }\n\n  .mobileReviewIconBox {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .mrMarginBottom {\n    margin-bottom: 5px;\n  }\n\n  .mrRemoveMargin {\n    margin-right: 0;\n  }\n\n  .mrListDeletBtnBox {\n    flex-direction: column;\n  }\n\n  .mobileFlexContainer {\n    flex-direction: column;\n  }\n\n  .mobileFlexContainer li {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .mobileDisplayBlock {\n    display: block;\n  }\n\n  .mobileTextCenter {\n    text-align: center;\n  }\n\n  .profileImageBg,\n  .bannerImageBg {\n    padding-top: 60%;\n  }\n\n  .trashIconNew {\n    top: 12px;\n    right: 12px;\n  }\n\n  .mobileTableSearch {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .commonBorderSection {\n    --wrapper-Padding: 18px;\n  }\n\n  .commonSearchInputFilterContainer {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .mobileTableOnlyLink {\n    align-items: flex-end;\n  }\n\n  .navTabFlex {\n    flex-direction: column;\n    align-items: stretch;\n    border: unset;\n  }\n}\n\n.displayGrid {\n  display: grid;\n}\n\n.gridCols2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.gap4 {\n  gap: 4px;\n}\n\n.gap6 {\n  gap: 6px;\n}\n\n.gap8 {\n  gap: 8px;\n}\n\n.gap12 {\n  gap: 12px;\n}\n\n.gap16 {\n  gap: 16px;\n}\n\n.gap24 {\n  gap: 24px;\n}\n\n.columnGap16 {\n  column-gap: 16px;\n}\n\n.rowGap18 {\n  row-gap: 18px;\n}\n\n.bt {\n  border-top: 1px solid var(--primary-border);\n}\n\n.languageBox>div:not(:first-child) {\n  padding-top: 24px;\n  border-top: 1px solid var(--primary-border);\n  margin-top: 24px;\n}\n\n.languageBtnContainerOne {\n  margin-bottom: 24px;\n}\n\n.languageBox>div:last-child .languageBtnContainerOne {\n  margin-bottom: 0;\n}\n\n.commonInputGrpDivider {\n  padding-bottom: 18px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n@media screen and (max-width: 991px) {\n  .gridColsTab1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .gapTab0 {\n    gap: 0px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .gridColsMobile1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .mobileFlexColumn {\n    flex-direction: column;\n  }\n\n  .mobileAlignFlexStretch {\n    align-items: stretch;\n  }\n}","@import url('../commonStyle.css');\n\n.plusIcon {\n   width: 20px;\n   height: 20px;\n   flex-shrink: 0;\n}\n\n.countryCodeSec {\n    padding: 14px 17px;\n    background: var(--btn-primary-bg);\n    color: var(--btn-primary-color);\n    border-radius: 6px 0px 0px 6px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.phoneNumberSec {\n    padding: 14px 20px;\n}\n\n.clearOption {\n    padding: 14px 20px 14px 0;\n}\n\n.phoneVerifyModal {\n    border-radius: 6px;\n}\n\n.iconSize {\n    max-width: 13px;\n    max-height: 13px;\n}\n\n.sendBtn {\n    white-space: normal;\n    word-break: break-word;\n}\n\n.confirmedText {\n    color: var(--verified-color);\n}\n\n.confirmedIcon {\n    width: 12px;\n    height: 8px;\n    margin-right: 3px;\n    vertical-align: baseline;\n}\n\n\n@media screen and (max-width:767px) {\n\n    .phoneNumberSec {\n        padding-right: 10px;\n        padding-left: 10px;\n    }\n\n    .countryCodeSec {\n        padding-inline: 12px;\n    }\n\n    .phoneVerifyModal {\n        padding: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnPrimary": `PhoneVerificationModal-btnPrimary-P6uiT`,
	"btnPrimaryBorder": `PhoneVerificationModal-btnPrimaryBorder-msYbs`,
	"btnSecondary": `PhoneVerificationModal-btnSecondary-rmVpP`,
	"btnPrimaryLink": `PhoneVerificationModal-btnPrimaryLink-dZE9q`,
	"nofocus": `PhoneVerificationModal-nofocus-iLFiq`,
	"btnSmall": `PhoneVerificationModal-btnSmall-pqJv1`,
	"btnBig": `PhoneVerificationModal-btnBig-lebx3`,
	"fullWidth": `PhoneVerificationModal-fullWidth-NT3iQ`,
	"WidthAuto": `PhoneVerificationModal-WidthAuto-Le8bL`,
	"fullHeight": `PhoneVerificationModal-fullHeight-Et2g2`,
	"noTextDecration": `PhoneVerificationModal-noTextDecration-QaUVQ`,
	"commonListStyleNone": `PhoneVerificationModal-commonListStyleNone-vmwtF`,
	"btnMedium": `PhoneVerificationModal-btnMedium-F9ODH`,
	"btnMediumSpace": `PhoneVerificationModal-btnMediumSpace-RCbJ7`,
	"btnMediumPadding": `PhoneVerificationModal-btnMediumPadding-pMtmQ`,
	"aiAskButton": `PhoneVerificationModal-aiAskButton-hoVoV`,
	"aiBadgeStyle": `PhoneVerificationModal-aiBadgeStyle-h49Bn`,
	"aiTextColor": `PhoneVerificationModal-aiTextColor-e5vlb`,
	"aiFooterInfoText": `PhoneVerificationModal-aiFooterInfoText-k55g8`,
	"regenerateBtn": `PhoneVerificationModal-regenerateBtn-KIXLL`,
	"textAlignRight": `PhoneVerificationModal-textAlignRight-Wv1By`,
	"textAlignLeft": `PhoneVerificationModal-textAlignLeft-Hn2kK`,
	"textAlignCenter": `PhoneVerificationModal-textAlignCenter-FlFUC`,
	"formControlInput": `PhoneVerificationModal-formControlInput-Fq4qK`,
	"formControlSelect": `PhoneVerificationModal-formControlSelect-bVJxL`,
	"noTextDecoration": `PhoneVerificationModal-noTextDecoration-zbExc`,
	"picContainerMain": `PhoneVerificationModal-picContainerMain-GTurC`,
	"profilePic": `PhoneVerificationModal-profilePic-wgenz`,
	"trashIcon": `PhoneVerificationModal-trashIcon-hMzYn`,
	"trashIconNew": `PhoneVerificationModal-trashIconNew-H7OwR`,
	"bannerImageBg": `PhoneVerificationModal-bannerImageBg-nWjqT`,
	"profileImageBg": `PhoneVerificationModal-profileImageBg-K4YDt`,
	"whiteImg": `PhoneVerificationModal-whiteImg-bWxU2`,
	"curserPointer": `PhoneVerificationModal-curserPointer-H2lrP`,
	"adminLabelTextNew": `PhoneVerificationModal-adminLabelTextNew-lhfhP`,
	"radioBtn": `PhoneVerificationModal-radioBtn-AYoL7`,
	"displayinlineBlock": `PhoneVerificationModal-displayinlineBlock-KuBO9`,
	"displayBlock": `PhoneVerificationModal-displayBlock-KoSHT`,
	"displayFlex": `PhoneVerificationModal-displayFlex-VpIuW`,
	"inlineDisplayFlex": `PhoneVerificationModal-inlineDisplayFlex-d0Y_a`,
	"alignCenter": `PhoneVerificationModal-alignCenter-JuEUK`,
	"spaceBetween": `PhoneVerificationModal-spaceBetween-OBwx3`,
	"alignItemFlexStart": `PhoneVerificationModal-alignItemFlexStart-h8Xtr`,
	"commonTitleText": `PhoneVerificationModal-commonTitleText-YW6gD`,
	"commonSubTitleText": `PhoneVerificationModal-commonSubTitleText-Utvv9`,
	"commonContentText": `PhoneVerificationModal-commonContentText-oKGYq`,
	"commonMediumText": `PhoneVerificationModal-commonMediumText-DDWob`,
	"commonTotalText": `PhoneVerificationModal-commonTotalText-UvYQ0`,
	"commonSmallText": `PhoneVerificationModal-commonSmallText-NY7Go`,
	"fontWeightExtraBold": `PhoneVerificationModal-fontWeightExtraBold-bs1Kx`,
	"fontWeightBold": `PhoneVerificationModal-fontWeightBold-JDEoJ`,
	"fontWeightMedium": `PhoneVerificationModal-fontWeightMedium-tILQ3`,
	"fontWeightNormal": `PhoneVerificationModal-fontWeightNormal-spVWP`,
	"textDecorationUnderLine": `PhoneVerificationModal-textDecorationUnderLine-SFgjI`,
	"textDecorationNone": `PhoneVerificationModal-textDecorationNone-L7Z7k`,
	"siteLinkColor": `PhoneVerificationModal-siteLinkColor-AtN5C`,
	"commonLinkBorderBottom": `PhoneVerificationModal-commonLinkBorderBottom-PcgxW`,
	"siteTextColor": `PhoneVerificationModal-siteTextColor-P3bLL`,
	"positionRelative": `PhoneVerificationModal-positionRelative-BE6f5`,
	"listingHorizoltalLine": `PhoneVerificationModal-listingHorizoltalLine-eIOrB`,
	"spaceBottom0": `PhoneVerificationModal-spaceBottom0-NhsC8`,
	"spaceBottom1": `PhoneVerificationModal-spaceBottom1-_yTzl`,
	"spaceBottom2": `PhoneVerificationModal-spaceBottom2-uflPy`,
	"spaceBottom3": `PhoneVerificationModal-spaceBottom3-JKa9G`,
	"spaceBottom4": `PhoneVerificationModal-spaceBottom4-dbO0k`,
	"spaceBottom5": `PhoneVerificationModal-spaceBottom5-qk5E3`,
	"spaceBottom6": `PhoneVerificationModal-spaceBottom6-ajQv3`,
	"spaceBottom7": `PhoneVerificationModal-spaceBottom7-FzhtS`,
	"spaceBottom8": `PhoneVerificationModal-spaceBottom8-LyWk0`,
	"spaceTop0": `PhoneVerificationModal-spaceTop0-JDYEg`,
	"spaceTop1": `PhoneVerificationModal-spaceTop1-OBuOx`,
	"spaceTop2": `PhoneVerificationModal-spaceTop2-kdSsd`,
	"spaceTop3": `PhoneVerificationModal-spaceTop3-_DvDF`,
	"spaceTop4": `PhoneVerificationModal-spaceTop4-AGEjU`,
	"spaceTop5": `PhoneVerificationModal-spaceTop5-F8OQm`,
	"spaceTop6": `PhoneVerificationModal-spaceTop6-urYzu`,
	"spaceTop7": `PhoneVerificationModal-spaceTop7-ZVpMw`,
	"paddingBottom1": `PhoneVerificationModal-paddingBottom1-HqiML`,
	"paddingBottom2": `PhoneVerificationModal-paddingBottom2-SEg4E`,
	"paddingBottom3": `PhoneVerificationModal-paddingBottom3-R1Yk1`,
	"paddingBottom4": `PhoneVerificationModal-paddingBottom4-yaCtX`,
	"paddingBottom5": `PhoneVerificationModal-paddingBottom5-rSMBg`,
	"paddingBottom6": `PhoneVerificationModal-paddingBottom6-ueji_`,
	"paddingBottom7": `PhoneVerificationModal-paddingBottom7-J4FCV`,
	"paddingTop1": `PhoneVerificationModal-paddingTop1-I82t6`,
	"paddingTop2": `PhoneVerificationModal-paddingTop2-smJp4`,
	"paddingTop3": `PhoneVerificationModal-paddingTop3-IXGa5`,
	"paddingTop4": `PhoneVerificationModal-paddingTop4-nkjLC`,
	"paddingTop5": `PhoneVerificationModal-paddingTop5-lo4Y5`,
	"paddingTop6": `PhoneVerificationModal-paddingTop6-EBpTW`,
	"paddingTop7": `PhoneVerificationModal-paddingTop7-vmZ28`,
	"spaceRight1": `PhoneVerificationModal-spaceRight1-haqX3`,
	"spaceRight2": `PhoneVerificationModal-spaceRight2-SJ3CL`,
	"spaceRight3": `PhoneVerificationModal-spaceRight3-h5LNh`,
	"spaceRight4": `PhoneVerificationModal-spaceRight4-PpCGD`,
	"paddingBottom8": `PhoneVerificationModal-paddingBottom8-mfEd2`,
	"spaceTop8": `PhoneVerificationModal-spaceTop8-ohqx9`,
	"paddingBottomNone": `PhoneVerificationModal-paddingBottomNone-U_okQ`,
	"spaceBottom9": `PhoneVerificationModal-spaceBottom9-ZUfZU`,
	"spaceBottom10": `PhoneVerificationModal-spaceBottom10-azhUF`,
	"spaceBottom11": `PhoneVerificationModal-spaceBottom11-mCB9s`,
	"spaceBottom12": `PhoneVerificationModal-spaceBottom12-ysYMh`,
	"noPadding": `PhoneVerificationModal-noPadding-PND3z`,
	"flexShrinkNone": `PhoneVerificationModal-flexShrinkNone-eLGGf`,
	"viewListIcon": `PhoneVerificationModal-viewListIcon-TGwWR`,
	"blueLeftArrow": `PhoneVerificationModal-blueLeftArrow-_yON0`,
	"profileAvatarLink": `PhoneVerificationModal-profileAvatarLink-wv08Q`,
	"profileAvatarLinkSmall": `PhoneVerificationModal-profileAvatarLinkSmall-rlP3C`,
	"errorMessage": `PhoneVerificationModal-errorMessage-UhqB8`,
	"textTransformLowerCase": `PhoneVerificationModal-textTransformLowerCase-swV8r`,
	"passwordIcon": `PhoneVerificationModal-passwordIcon-p8Eh5`,
	"noMargin": `PhoneVerificationModal-noMargin-prE0u`,
	"noMarginBottom": `PhoneVerificationModal-noMarginBottom-am61M`,
	"dotCss": `PhoneVerificationModal-dotCss-V5z_n`,
	"dateArrowMargin": `PhoneVerificationModal-dateArrowMargin-dxdnQ`,
	"commonBorderSection": `PhoneVerificationModal-commonBorderSection-hKAuA`,
	"vtrMiddle": `PhoneVerificationModal-vtrMiddle-WWgqj`,
	"positionAvatar": `PhoneVerificationModal-positionAvatar-z3Xf0`,
	"dFlex": `PhoneVerificationModal-dFlex-bUVJL`,
	"flexWrap": `PhoneVerificationModal-flexWrap-DenVB`,
	"dInlineFlex": `PhoneVerificationModal-dInlineFlex-O9px0`,
	"dFlexContainer": `PhoneVerificationModal-dFlexContainer-lulOU`,
	"dFlexWrap": `PhoneVerificationModal-dFlexWrap-r6MRC`,
	"dFlexWrapAlignEnd": `PhoneVerificationModal-dFlexWrapAlignEnd-gNw0Y`,
	"dFlexWrapAlignStart": `PhoneVerificationModal-dFlexWrapAlignStart-hzDG6`,
	"justifyContentSpaceBetween": `PhoneVerificationModal-justifyContentSpaceBetween-W0rN9`,
	"greyText": `PhoneVerificationModal-greyText-EKD8h`,
	"tripsReservationPanel": `PhoneVerificationModal-tripsReservationPanel-cNeIP`,
	"listContainer": `PhoneVerificationModal-listContainer-PpKQx`,
	"listTabItem": `PhoneVerificationModal-listTabItem-LHYih`,
	"reviewsContainer": `PhoneVerificationModal-reviewsContainer-mcTE2`,
	"reviewsYourItemsOne": `PhoneVerificationModal-reviewsYourItemsOne-m9rUX`,
	"reviewsYourItemsTwo": `PhoneVerificationModal-reviewsYourItemsTwo-UqznW`,
	"rightBg": `PhoneVerificationModal-rightBg-XNpYF`,
	"commonProfileAvatarLink": `PhoneVerificationModal-commonProfileAvatarLink-cmkWi`,
	"writtenReviewTitle": `PhoneVerificationModal-writtenReviewTitle-KQu0W`,
	"reviewTitleLink": `PhoneVerificationModal-reviewTitleLink-tg9wY`,
	"reviewFlex": `PhoneVerificationModal-reviewFlex-yF1S_`,
	"noTop": `PhoneVerificationModal-noTop-fCY9v`,
	"reviewPara": `PhoneVerificationModal-reviewPara-cNvsg`,
	"dFlexColumn": `PhoneVerificationModal-dFlexColumn-Y2fqD`,
	"commonlineCss": `PhoneVerificationModal-commonlineCss-qdK4s`,
	"loadBtn": `PhoneVerificationModal-loadBtn-cBKrq`,
	"vtrTop": `PhoneVerificationModal-vtrTop-wTUPd`,
	"reviewHeadingColor": `PhoneVerificationModal-reviewHeadingColor-AaicX`,
	"reviewWriteHeading": `PhoneVerificationModal-reviewWriteHeading-zj0aQ`,
	"noDataImgSize": `PhoneVerificationModal-noDataImgSize-LH9gE`,
	"justifyCenter": `PhoneVerificationModal-justifyCenter-E3kNg`,
	"btnTextBrk": `PhoneVerificationModal-btnTextBrk-Cbubr`,
	"marginInlineAuto": `PhoneVerificationModal-marginInlineAuto-uVPaH`,
	"noItemPanel": `PhoneVerificationModal-noItemPanel-DEh2w`,
	"textLineBreak": `PhoneVerificationModal-textLineBreak-MRN38`,
	"displayInlineBlock": `PhoneVerificationModal-displayInlineBlock-joZZF`,
	"commonContainerList": `PhoneVerificationModal-commonContainerList-Ah_VF`,
	"adminBorderWithoutPadding": `PhoneVerificationModal-adminBorderWithoutPadding-bl8GO`,
	"marginRight8": `PhoneVerificationModal-marginRight8-jXTsB`,
	"adminDotIconBtn": `PhoneVerificationModal-adminDotIconBtn-S8nl4`,
	"commonLinkBorder": `PhoneVerificationModal-commonLinkBorder-FSD3E`,
	"commonTabelDropDownBg": `PhoneVerificationModal-commonTabelDropDownBg-OU_tN`,
	"tabelDropDownBtn": `PhoneVerificationModal-tabelDropDownBtn-jm1VT`,
	"tableHorizantalLine": `PhoneVerificationModal-tableHorizantalLine-juUmQ`,
	"backArrowStyle": `PhoneVerificationModal-backArrowStyle-jj9XX`,
	"csvImageSpace": `PhoneVerificationModal-csvImageSpace-NMF_l`,
	"flexEnd": `PhoneVerificationModal-flexEnd-SeA3Y`,
	"justifyContentFlexEnd": `PhoneVerificationModal-justifyContentFlexEnd-r0nZj`,
	"profileAvatarLinkPayment": `PhoneVerificationModal-profileAvatarLinkPayment-TST7G`,
	"alignItemBaseline": `PhoneVerificationModal-alignItemBaseline-p3DZ4`,
	"payOutToolTip": `PhoneVerificationModal-payOutToolTip-fytLG`,
	"tolltipMargin": `PhoneVerificationModal-tolltipMargin-Tp06q`,
	"textNoWrap": `PhoneVerificationModal-textNoWrap-hDzsE`,
	"commonSearchInputFilterContainer": `PhoneVerificationModal-commonSearchInputFilterContainer-myuIb`,
	"mobileTableSearch": `PhoneVerificationModal-mobileTableSearch-vQlXX`,
	"mobileTableOnlyLink": `PhoneVerificationModal-mobileTableOnlyLink-4WwDs`,
	"linkBtnPrimaryStyle": `PhoneVerificationModal-linkBtnPrimaryStyle-WERtf`,
	"dataTableGrid": `PhoneVerificationModal-dataTableGrid-Zl0q9`,
	"paymentDivider": `PhoneVerificationModal-paymentDivider-oSySJ`,
	"bulletList": `PhoneVerificationModal-bulletList-zndbV`,
	"commonSmallText14": `PhoneVerificationModal-commonSmallText14-Nw8pE`,
	"commonSmallText16": `PhoneVerificationModal-commonSmallText16-UrpZB`,
	"commonSmallText18": `PhoneVerificationModal-commonSmallText18-XUsNj`,
	"commonSmallText20": `PhoneVerificationModal-commonSmallText20-Ydp4r`,
	"commonSmallText24": `PhoneVerificationModal-commonSmallText24-pqc1D`,
	"commonSmallText26": `PhoneVerificationModal-commonSmallText26-FEEkG`,
	"top1": `PhoneVerificationModal-top1-paHdB`,
	"top2": `PhoneVerificationModal-top2-ZtOqg`,
	"top3": `PhoneVerificationModal-top3-MGGG5`,
	"topMinus1": `PhoneVerificationModal-topMinus1-kWet_`,
	"topMinus2": `PhoneVerificationModal-topMinus2-WAGtA`,
	"topMinus3": `PhoneVerificationModal-topMinus3-vF2ZA`,
	"textEnd": `PhoneVerificationModal-textEnd-zB6Zw`,
	"textStart": `PhoneVerificationModal-textStart-tTLWx`,
	"flexGrow": `PhoneVerificationModal-flexGrow-oT3lX`,
	"imageUploadDropzoneSection": `PhoneVerificationModal-imageUploadDropzoneSection-Shroj`,
	"imageUploadDropzoneSectionOutline": `PhoneVerificationModal-imageUploadDropzoneSectionOutline-E92Hj`,
	"commonDropZoneImgContainer": `PhoneVerificationModal-commonDropZoneImgContainer-vYSLg`,
	"commonDropZoneDefaultImg": `PhoneVerificationModal-commonDropZoneDefaultImg-FhZFk`,
	"navTabFlex": `PhoneVerificationModal-navTabFlex-u1QR8`,
	"navTabLink": `PhoneVerificationModal-navTabLink-qhM4D`,
	"activeTabStyle": `PhoneVerificationModal-activeTabStyle-nzvZr`,
	"listingCardCarTypeAndTransmissionLabelFlexContainer": `PhoneVerificationModal-listingCardCarTypeAndTransmissionLabelFlexContainer-YWogc`,
	"transmissionLabelText": `PhoneVerificationModal-transmissionLabelText-aKNNC`,
	"carTypeIcon": `PhoneVerificationModal-carTypeIcon-BChAg`,
	"textFlow": `PhoneVerificationModal-textFlow-vHpU1`,
	"dividerBorder": `PhoneVerificationModal-dividerBorder-iEBwj`,
	"commonNoteText": `PhoneVerificationModal-commonNoteText-ONKQE`,
	"paymentSticky": `PhoneVerificationModal-paymentSticky-rVCTO`,
	"btnWidth": `PhoneVerificationModal-btnWidth-HGojn`,
	"mobTextCenter": `PhoneVerificationModal-mobTextCenter-cLHdm`,
	"mobileReviewIconBox": `PhoneVerificationModal-mobileReviewIconBox-G2K3u`,
	"mrMarginBottom": `PhoneVerificationModal-mrMarginBottom-MiwCf`,
	"mrRemoveMargin": `PhoneVerificationModal-mrRemoveMargin-cZi6x`,
	"mrListDeletBtnBox": `PhoneVerificationModal-mrListDeletBtnBox-DsGRT`,
	"mobileFlexContainer": `PhoneVerificationModal-mobileFlexContainer-c0VUo`,
	"mobileDisplayBlock": `PhoneVerificationModal-mobileDisplayBlock-J7IZr`,
	"mobileTextCenter": `PhoneVerificationModal-mobileTextCenter-U9f_n`,
	"displayGrid": `PhoneVerificationModal-displayGrid-waGLl`,
	"gridCols2": `PhoneVerificationModal-gridCols2-R0YRg`,
	"gap4": `PhoneVerificationModal-gap4-vxkcn`,
	"gap6": `PhoneVerificationModal-gap6-R0pDt`,
	"gap8": `PhoneVerificationModal-gap8-o2imu`,
	"gap12": `PhoneVerificationModal-gap12-hLhAX`,
	"gap16": `PhoneVerificationModal-gap16-I0o9B`,
	"gap24": `PhoneVerificationModal-gap24-luMax`,
	"columnGap16": `PhoneVerificationModal-columnGap16-qQ7kG`,
	"rowGap18": `PhoneVerificationModal-rowGap18-V3tDZ`,
	"bt": `PhoneVerificationModal-bt-uLV05`,
	"languageBox": `PhoneVerificationModal-languageBox-cPTOW`,
	"languageBtnContainerOne": `PhoneVerificationModal-languageBtnContainerOne-FOaDC`,
	"commonInputGrpDivider": `PhoneVerificationModal-commonInputGrpDivider-zNMZm`,
	"gridColsTab1": `PhoneVerificationModal-gridColsTab1-u2xGh`,
	"gapTab0": `PhoneVerificationModal-gapTab0-KC5rb`,
	"gridColsMobile1": `PhoneVerificationModal-gridColsMobile1-NA6Ui`,
	"mobileFlexColumn": `PhoneVerificationModal-mobileFlexColumn-MPD1G`,
	"mobileAlignFlexStretch": `PhoneVerificationModal-mobileAlignFlexStretch-m0ZWJ`,
	"plusIcon": `PhoneVerificationModal-plusIcon-SaGgo`,
	"countryCodeSec": `PhoneVerificationModal-countryCodeSec-iNso6`,
	"phoneNumberSec": `PhoneVerificationModal-phoneNumberSec-hclzS`,
	"clearOption": `PhoneVerificationModal-clearOption-U3wUM`,
	"phoneVerifyModal": `PhoneVerificationModal-phoneVerifyModal-5yUve`,
	"iconSize": `PhoneVerificationModal-iconSize-ckTTh`,
	"sendBtn": `PhoneVerificationModal-sendBtn-Rzx3g`,
	"confirmedText": `PhoneVerificationModal-confirmedText-P5fQU`,
	"confirmedIcon": `PhoneVerificationModal-confirmedIcon-EdXrB`
};
module.exports = ___CSS_LOADER_EXPORT___;
